import { render, staticRenderFns } from "./FreezeRecords.vue?vue&type=template&id=b7c51562&scoped=true"
import script from "./FreezeRecords.vue?vue&type=script&lang=js"
export * from "./FreezeRecords.vue?vue&type=script&lang=js"
import style0 from "./FreezeRecords.vue?vue&type=style&index=0&id=b7c51562&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c51562",
  null
  
)

export default component.exports